export default __webpack_public_path__ + "static/media/curiosite.56a62537.jpg";